const ConversionLkp = {
  mm: {
    rem: 0.23622050220101,
  },
  in: {
    rem: 6.0000007559056,
  },
}

export default class UnitConverter {
  static convert(from, to, value) {
    if (typeof ConversionLkp[from] === 'undefined') {
      throw new Error(`UnitConverter: from value '${from}' is not defined`)
    }
    if (typeof ConversionLkp[from][to] === 'undefined') {
      throw new Error(`UnitConverter: to value '${to}' is not defined`)
    }
    return value * ConversionLkp[from][to]
  }
  static InchesToRem(inches) {
    return inches * 6.0000007559056
  }
  static MillimetersToRem(mm) {
    return mm * 0.23622050220101
  }
}
